const payloadOf = (
    value
) =>
    value?.payload ??
    value ??
    {};


export function PositionPanel({
    position,
}) {

    const payload =
        payloadOf(
            position
        );


    const symbol =
        position?.symbol ??
        payload.symbol ??
        "—";


    const state =
        payload.state ??
        payload.lifecycleState ??
        payload.status ??
        "—";


    const side =
        payload.side ??
        payload.direction ??
        "—";


    const quantity =
        payload.quantity ??
        payload.remainingQuantity ??
        "—";


    const pnl =
        payload.realizedPnl ??
        payload.unrealizedPnl ??
        "—";


    return (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-5 shadow-xl shadow-black/10">

            <div className="mb-4 flex items-center justify-between">

                <div>
                    <p className="text-sm font-semibold text-slate-100">
                        Position Lifecycle
                    </p>

                    <p className="text-xs text-slate-500">
                        Read-only execution state
                    </p>
                </div>

                <span className="rounded-full bg-slate-800 px-3 py-1 text-xs text-slate-300">
                    {symbol}
                </span>

            </div>


            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">

                {[
                    [
                        "State",
                        state,
                    ],

                    [
                        "Side",
                        side,
                    ],

                    [
                        "Quantity",
                        quantity,
                    ],

                    [
                        "PnL",
                        pnl,
                    ],
                ].map(
                    (
                        [
                            label,
                            value,
                        ]
                    ) => (

                        <div
                            key={label}
                            className="rounded-xl bg-slate-950/70 p-3"
                        >

                            <p className="text-xs text-slate-500">
                                {label}
                            </p>

                            <p className="mt-1 truncate text-sm font-semibold text-slate-100">
                                {String(
                                    value
                                )}
                            </p>

                        </div>
                    )
                )}

            </div>

        </div>
    );
}